import { flow } from 'lodash'
import { connect } from 'react-redux'
import Slideshow from './Slideshow'
import withUserInput from '../../hocs/UserInput'
import withPager from '../../hocs/Pager'

const mapStateToProps = state => ({
  audioEnabled: state.audio.audioEnabled,
})
export default flow(
  withUserInput,
  withPager
)(connect(mapStateToProps)(Slideshow))



// WEBPACK FOOTER //
// ../core/src/components/Slideshow/index.js